import { ComfeSettings } from '../../types'

export function comfeSettingsFixture({
  enablePgsHostedFormV2 = true,
  enableDirectDebitAllPaymentFormV2 = false,
  enableBillingAccountType = true,
  enableVatExamples = true,
  billingAccountTypeFields = {
    business: {
      required: ['companyName', 'pecEmailOrRecipientCode', 'nonProfitTaxId'],
      optional: ['taxId']
    },
    consumer: {
      required: [],
      optional: ['taxId']
    }
  },
  enrollmentSecurityScriptBillingPath = '',
  enableVerifoneBillingAddress = false,
  enableSpainTaxIdValidation = false,
  enableBillingUpdatedLayout = false,
  enableVerifoneCombineStreets = false,
  enableEasyEnrollEMEA = false
} = {}): ComfeSettings {
  return {
    enrollmentSecurityScriptBillingPath,
    enablePgsHostedFormV2,
    enableDirectDebitAllPaymentFormV2,
    enableBillingAccountType,
    enableVatExamples,
    billingAccountTypeFields,
    enableVerifoneBillingAddress,
    enableSpainTaxIdValidation,
    enableBillingUpdatedLayout,
    enableVerifoneCombineStreets,
    enableEasyEnrollEMEA
  }
}
